import styled, { css } from "styled-components/macro";

const Grid = styled.div`
  display:block;
  & > *{
    float: left;
    margin: 10px;
  }
  margin-bottom: 1rem;

  @supports (display:grid) {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-gap: 1rem;
  & > *{
  float: none;
  width: 100%;
  margin: 0;
  }
  }

  button {
    color: #005fb2;
    background: transparent;
    border: 1px solid #005fb2;
    text-align: center;
    width: 28%;
 @supports (display:grid) {
    width: 100%;
 }
    padding: 0 .5rem 0rem;
    position: relative;


    cursor: pointer;
  }

  svg {
    width: 80px;
    padding: .2rem;
  }

  ${props =>
    props.dual &&
    css`
      button {
        width: 100%;
      }
      @supports (clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      ) {
        button::after {
          content: "";
          width: 30%;
          height: 70%;
          background: rgba(0, 95, 178, 0.2);
          -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      a {
        width: 40% !important;
      }
      @supports (display: grid) {
        grid-template-columns: repeat(2, 1fr);
        a {
          width: 100% !important;
        }
      }
    `}

  ${props =>
    props.subprofile &&
    css`
      button {
        width: 100%;
      }
      @supports (clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      ) {
        button::after {
          content: "";
          width: 30%;
          height: 70%;
          background: rgba(0, 95, 178, 0.2);
          -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      }
      a {
        width: 25% !important;
      }
      @supports (display: grid) {
        grid-template-columns: repeat(3, 1fr);
        a {
          width: 100% !important;
        }
      }
    `}
  ${props =>
    props.grey &&
    css`
      @supports (clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      ) {
        button::after {
          content: "";
          width: 15%;
          height: 70%;
          background: rgba(151, 151, 151, 0.2);
          -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      margin-bottom: 0rem;
      button {
        font-weight: normal;
        color: #999999;
        border: 1px solid #999999;
        background: transparent;
        p {
          margin: 0.5rem 0;
          padding: 0;
          @supports (display: grid) {
            padding: 0 0.5rem;
          }
          text-align: center;
        }
      }
    `}
  ${props =>
    props.icon &&
    css`
      svg {
        width: 30px;
        height: 30px;
        float: left;
      }
      button {
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0;
      }
      @supports (clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      ) {
        button::after {
          content: "";
          width: 25%;
          height: 70%;
          background: rgba(151, 151, 151, 0.2);
          -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          clip-path: polygon(100% 0, 0% 100%, 100% 100%);
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      margin-bottom: 0rem;
      button {
        font-weight: normal;
        color: #999999;
        border: 1px solid #999999;
        background: transparent;
        p {
          margin: 0.5rem 0;
          padding: 0;
          @supports (display: grid) {
            padding: 0 0.5rem;
          }
          text-align: center;
        }
      }
    `}
`;

export const Hex = styled.div`
  min-width: 95px !important;
  button {
    color: #ffffff;
    border: 1px solid #000000;

    &::after {
      display: none;
    }
  }
  &:nth-child(1) {
    button {
      background: #fabb00 !important;
    }
  }
  &:nth-child(2) {
    button {
      background: #d2091e !important;
      color: #ffffff;
    }
  }
  a {
    color: #ffffff;
  }
`;

export const Active = styled.button`
  min-width: 90px;
  padding: 0 1rem 0.5rem;
  border: 1px solid #005fb2 !important;
  color: #005fb2 !important;

  cursor: pointer;

  @supports (clip-path: polygon(100% 0, 0% 100%, 100% 100%)) {
    &::after {
      content: "";
      width: 20%;
      height: 70%;
      background: rgba(0, 95, 178, 0.2) !important;
      -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      clip-path: polygon(100% 0, 0% 100%, 100% 100%);
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  ${props =>
    props.icon &&
    css`
      width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0;
    `};
`;

export const Title = styled.p`
  text-transform: uppercase;
  font-weight: bolder;
  padding: 0 0.5rem;
`;
export const GreyButton = styled.button`
  border: #999999 1px solid !important;
  color: #999999 !important;
  &::after {
    display: none;
  }
`;

export default Grid;
